export default {
	inTransitions: [{
		label: 'Back entrances',
		options: [
			'backInDown',
			'backInLeft',
			'backInRight',
			'backInUp',
		]
	}, {
		label: 'Bouncing entrances',
		options: [
			'bounceIn',
			'bounceInDown',
			'bounceInLeft',
			'bounceInRight',
			'bounceInUp',
		]
	}, {
		label: 'Fading entrances',
		options: [
			'fadeIn',
			'fadeInDown',
			'fadeInDownBig',
			'fadeInLeft',
			'fadeInLeftBig',
			'fadeInRight',
			'fadeInRightBig',
			'fadeInUp',
			'fadeInUpBig',
			'fadeInTopLeft',
			'fadeInTopRight',
			'fadeInBottomLeft',
			'fadeInBottomRight',
		]
	}, {
		label: 'Flippers',
		options: [
			'flipInX',
			'flipInY',
		]
	}, {
		label: 'Lightspeed',
		options: [
			'lightSpeedInRight',
			'lightSpeedInLeft',
		]
	}, {
		label: 'Rotating entrances',
		options: [
			'rotateIn',
			'rotateInDownLeft',
			'rotateInDownRight',
			'rotateInUpLeft',
			'rotateInUpRight',
		]
	}, {
		label: 'Specials',
		options: [
			'jackInTheBox',
			'rollIn',
		]
	}, {
		label: 'Zooming entrances',
		options: [
			'zoomIn',
			'zoomInDown',
			'zoomInLeft',
			'zoomInRight',
			'zoomInUp',
		]
	}, {
		label: 'Sliding entrances',
		options: [
			'slideInDown',
			'slideInLeft',
			'slideInRight',
			'slideInUp',
		]
	}],
	outTransitions: [{
		label: 'Back exits',
		options: [
			'backOutDown',
			'backOutLeft',
			'backOutRight',
			'backOutUp',
		]
	}, {
		label: 'Bouncing exits',
		options: [
			'bounceOut',
			'bounceOutDown',
			'bounceOutLeft',
			'bounceOutRight',
			'bounceOutUp',
		]
	}, {
		label: 'Fading exits',
		options: [
			'fadeOut',
			'fadeOutDown',
			'fadeOutDownBig',
			'fadeOutLeft',
			'fadeOutLeftBig',
			'fadeOutRight',
			'fadeOutRightBig',
			'fadeOutUp',
			'fadeOutUpBig',
			'fadeOutTopLeft',
			'fadeOutTopRight',
			'fadeOutBottomRight',
			'fadeOutBottomLeft',
		]
	}, {
		label: 'Flippers',
		options: [
			'flipOutX',
			'flipOutY',
		]
	}, {
		label: 'Lightspeed',
		options: [
			'lightSpeedOutRight',
			'lightSpeedOutLeft',
		]
	}, {
		label: 'Rotating exits',
		options: [
			'rotateOut',
			'rotateOutDownLeft',
			'rotateOutDownRight',
			'rotateOutUpLeft',
			'rotateOutUpRight',
		]
	}, {
		label: 'Specials',
		options: [
			'rollOut',
		]
	}, {
		label: 'Zooming exits',
		options: [
			'zoomOut',
			'zoomOutDown',
			'zoomOutLeft',
			'zoomOutRight',
			'zoomOutUp',
		]
	}, {
		label: 'Sliding exits',
		options: [
			'slideOutDown',
			'slideOutLeft',
			'slideOutRight',
			'slideOutUp',
		]
	}]

}
